import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { signOut, getAuth } from "firebase/auth";
import { getDoc, doc, collection, query, where, getDocs } from "firebase/firestore";
import auth from "./auth";
import { db } from "../firebaseConfig";
import lego222 from "./Lego222.png";

function NavBar({ showBackButton }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [createMenuOpen, setCreateMenuOpen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [user, setUser] = useState(null);
  const menuRef = useRef(null);
  const createMenuRef = useRef(null);
  const authInstance = getAuth();

  // State to detect mobile screen size
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Styling objects adjusted to screen size
  const navButtonStyle = {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: isMobile ? "14px" : "18px",
    color: "white",
    fontWeight: "bold",
  };

  const dropdownButtonStyle = {
    display: "block",
    width: "100%",
    padding: "10px",
    textAlign: "left",
    background: "none",
    border: "none",
    cursor: "pointer",
  };

  const dropdownOptionStyle = {
    display: "block",
    width: "100%",
    padding: "10px",
    textAlign: "left",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    color: "white",
    transition: "background-color 0.2s",
  };

  const handleLogout = async () => {
    try {
      await signOut(authInstance);
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = authInstance.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const checkUserDetails = async () => {
      try {
        const currentUser = authInstance.currentUser;
        if (!currentUser) return;

        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        const userHasStripeId = userDoc.exists() && userDoc.data().stripeAccountId;

        const carsQuery = query(collection(db, "cars"), where("userID", "==", currentUser.uid));
        const carsSnapshot = await getDocs(carsQuery);
        const userHasCars = carsSnapshot.size > 0;

        setShowWarning(userHasCars && !userHasStripeId);
      } catch (error) {
        console.error("Error checking user details:", error);
      }
    };

    checkUserDetails();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
      if (createMenuRef.current && !createMenuRef.current.contains(event.target)) {
        setCreateMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: isMobile ? "10px 15px" : "20px 25px",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          background: "linear-gradient(to right, rgb(32, 32, 39), #1e1e1e, rgb(16, 16, 17))",
          color: "white",
          zIndex: 1000,
          flexWrap: "wrap",
        }}
      >
        {/* GEARSHARE Button */}
        <button
          onClick={() => navigate("/marketplace")}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: isMobile ? "24px" : "28px",
            fontWeight: "bold",
            color: "white",
            marginRight: isMobile ? "10px" : "200px",
            marginLeft: "0px",
          }}
        >
          <img src={lego222} alt="Logo" style={{ height: isMobile ? "30px" : "40px" }} />
        </button>

        {/* Desktop Navigation Links */}
        {!isMobile && (
          <div
            style={{
              display: "flex",
              gap: "40px",
              justifyContent: "flex-end",
              flexGrow: 1,
              marginRight: "50px",
            }}
          >
            {!user && (
              <>
                <button onClick={() => navigate("/how-it-works")} style={navButtonStyle}>
                  HOW IT WORKS
                </button>
                <button onClick={() => navigate("/why-cars")} style={navButtonStyle}>
                  WHY CARS
                </button>
                <button onClick={() => navigate("/about")} style={navButtonStyle}>
                  ABOUT
                </button>
              </>
            )}
            <button onClick={() => navigate("/marketplace")} style={navButtonStyle}>
              MARKETPLACE
            </button>
            <button onClick={() => navigate("/RentalPage")} style={navButtonStyle}>
              RENT
            </button>
            {user && (
              <>
                <button onClick={() => navigate("/rankings")} style={navButtonStyle}>
                  RANKINGS
                </button>
                <button onClick={() => navigate("/investments")} style={navButtonStyle}>
                  MY INVESTMENTS
                </button>
              </>
            )}
          </div>
        )}

    

        {/* Authenticated Section */}
        {user ? (
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            {!isMobile && (
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => setCreateMenuOpen(!createMenuOpen)}
                  style={{
                    backgroundColor: "#18A0FF",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  + Create Listing
                </button>
                {createMenuOpen && (
                  <div
                    ref={createMenuRef}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      backgroundColor: "#18A0FF",
                      borderRadius: "4px",
                      boxShadow: "0 4px 6px rgba(255, 255, 255, 0.1)",
                      zIndex: 1000,
                      minWidth: "200px",
                      marginTop: "5px",
                      color: "white",
                    }}
                  >
                    <button onClick={() => navigate("/create-single-listing")} style={dropdownOptionStyle}>
                      Create Single Listing
                    </button>
                    <button onClick={() => navigate("/private-listing")} style={dropdownOptionStyle}>
                      Create a Private Batch
                    </button>
                    <button onClick={() => navigate("/create-a-fleet")} style={dropdownOptionStyle}>
                      Create a Fleet
                    </button>
                  </div>
                )}
              </div>
            )}
            <button
              onClick={() => navigate("/profile")}
              style={{ background: "none", border: "none", cursor: "pointer", marginRight: "10px" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="30px" height="30px">
                <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z" />
                <path d="M12 14c-4.41 0-8 1.79-8 4v2h16v-2c0-2.21-3.59-4-8-4z" />
              </svg>
            </button>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="30px" height="30px">
                <path d="M3 6h18v2H3zM3 12h18v2H3zM3 18h18v2H3z" />
              </svg>
            </button>
            {menuOpen && (
              <div
                ref={menuRef}
                style={{
                  position: "absolute",
                  top: "100%",
                  right: "0",
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  zIndex: 1000,
                  minWidth: "150px",
                  marginRight: "0px",
                  marginTop: "10px",
                }}
              >
                <button onClick={() => navigate("/how-it-works")} style={dropdownButtonStyle}>
                  How It Works
                </button>
                <button onClick={() => navigate("/settings")} style={dropdownButtonStyle}>
                  Payment Methods
                </button>
                <button onClick={() => navigate("/requests")} style={dropdownButtonStyle}>
                  Pending Approvals
                </button>
                <button onClick={() => navigate("/terms-of-service")} style={dropdownButtonStyle}>
                  Terms of Service
                </button>
                <button onClick={() => navigate("/feedback")} style={dropdownButtonStyle}>
                  Feedback & Support
                </button>
                <button onClick={handleLogout} style={dropdownButtonStyle}>
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <button
            onClick={() => navigate("/login")}
            style={{
              backgroundColor: "#18A0FF",
              color: "#fff",
              border: "none",
              padding: isMobile ? "10px 15px" : "15px 30px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Login
          </button>
        )}
      </nav>

      {showWarning && (
        <div
          style={{
            backgroundColor: "#ffcccc",
            color: "#b22222",
            padding: "10px 20px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Update your{" "}
          <a href="/settings" style={{ color: "#007bff", textDecoration: "underline" }}>
            Payment Methods
          </a>{" "}
          to receive payouts.
        </div>
      )}
    </>
  );
}

export default NavBar;
